import React from "react";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class TooltipIcon extends React.Component {

    render() {
        return (
            <>
                <FontAwesomeIcon icon={['fa', this.props.icon]} data-tip data-for={this.props.id} className={this.props.className} />
                <ReactTooltip id={this.props.id} className={"custom-tooltip"}>
                    {this.props.message}
                </ReactTooltip>
            </>
        );
    }
}

export default TooltipIcon;